"use strict";


//=============WebAuidioApi===



//=============repris de modifier de MDN===
var audioCtx;
startUserMedia();
function startUserMedia() {
    if(!audioCtx){
      audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    } ;
};
var myAudio = document.querySelector('audio');
var distortion = audioCtx.createWaveShaper();
var analyser = audioCtx.createAnalyser();
var source = audioCtx.createMediaElementSource(myAudio);
var biquadFilter = audioCtx.createBiquadFilter();
var biquadFilter2 = audioCtx.createBiquadFilter();
var biquadFilter3 = audioCtx.createBiquadFilter();
var biquadFilter4 = audioCtx.createBiquadFilter();
var canvasCtx =document.querySelector(".visualizer");

function makeDistortionCurve(amount) {
    var k = typeof amount === 'number' ? amount : 50,
      n_samples = 44100,
      curve = new Float32Array(n_samples),
      deg = Math.PI / 180,
      i = 0,
      x;
    for ( ; i < n_samples; ++i ) {
      x = i * 2 / n_samples - 1;
      curve[i] = ( 3 + k ) * x * 20 * deg / ( Math.PI + k * Math.abs(x) );
    }
    return curve;
};

biquadFilter.type="allpass";
biquadFilter2.type="allpass";
biquadFilter3.type="allpass";
biquadFilter4.type="allpass";

source.connect(biquadFilter);
biquadFilter.connect(biquadFilter2);
biquadFilter2.connect(biquadFilter3);
biquadFilter3.connect(biquadFilter4);
biquadFilter4.connect(distortion);
distortion.connect(analyser);
analyser.connect(audioCtx.destination);


//=============https://codepen.io/nfj525/pen/rVBaab repris et modifié===

var canvas = document.getElementById("canvas");
canvas.width = window.innerWidth;
canvas.height = 150;
var ctx = canvas.getContext("2d");
  
analyser.fftSize = 256;
  
var bufferLength = analyser.frequencyBinCount;
  
var dataArray = new Uint8Array(bufferLength);
  
var WIDTH = canvas.width;
var HEIGHT = canvas.height;
  
var barWidth = (WIDTH / bufferLength) * 5;
var barHeight;
var x = 0;
  
function renderFrame() {
    requestAnimationFrame(renderFrame);

    x = 0;

    analyser.getByteFrequencyData(dataArray);

    ctx.fillStyle = "#1F0E17";
    ctx.fillRect(0, 0, WIDTH, HEIGHT);

    for (var i = 0; i < bufferLength; i++) {
      barHeight = dataArray[i]/2;
    
      var r = barHeight + (25 * (i/bufferLength));
      var g = 250 * (i/bufferLength);
      var b = 50;

      ctx.fillStyle = "rgb(" + r + "," + g + "," + b + ")";
      ctx.fillRect(x, HEIGHT - barHeight, barWidth, barHeight);

      x += barWidth + 1;
    }
}
renderFrame();


//=============Initialisation des variables===


var ChoixMusiqueMechant = document.querySelector(".starter-page__el--mechants");
var ChoixMusiqueArisocrate = document.querySelector(".starter-page__el--aristocrate");
var ChoixMusiqueMoulaga = document.querySelector(".starter-page__el--moulaga");
var ChoixMusiqueCompteur;
var MusiqueMain = document.querySelector(".main");
var MusiqueFooter = document.querySelector(".footer");
var BtnSideAristocrate=document.querySelectorAll(".btn__content--aristocrate");
var BtnSideMechants=document.querySelectorAll(".btn__content--mechants");
var BtnSideMoulaga=document.querySelectorAll(".btn__content--moulaga");
var BtnSide=document.querySelectorAll(".btn__content");

const InfosJson = ["Artiste","Feat","Titre","Album","Durée","DuréeSec","Certification","DescriptionCertification","Cover","Bpm","Clé","Game","Basse","DateSortie","Texte","Stream","StreamMoisMax","StreamTotal","SteamSemaineMax"];
const MusiqueJson = ["Aristocrate","Les Méchants","Moulaga"];
var TitreMusique = document.querySelector(".title--nom");
var SmallArtiste = document.querySelector(".artist--banner");
var TitreChoixMusique = document.querySelector(".title--musique");
var ElementCouleur = document.querySelectorAll(".element-color");
var FlecheHome = document.querySelector(".btn-home__cible");

var FlecheGauche = document.querySelector(".switch-filter--left");
var FlecheDroite = document.querySelector(".switch-filter--right");
var listeEffets = ["Aigü","Basses","Vitesse","Distortion","Passe-bande","Coupe-bande"];
var listeExplain = ["Modifiez l'intensité des aigüs !","Modifiez l'intensité des basses !","Modifiez la vitesse de lecture de la musique !","Modifiez l'intensité de la distortion !","Modifiez l'intensié du Passe-bande !","Modifiez l'intensité du Coupe-bande"];
var EffetFirst = document.querySelector(".filter-name--first");
var EffetActive = document.querySelector(".filter-name--active");
var EffetSecond = document.querySelector(".filter-name--second");
var EffetDescription = document.querySelector(".filter-explain");
var btnclick=0;
var BPM=0;

var TopNombreAri = ["","","","","","","","","",""];
var TopMotAri = ["","","","","","","","",""];
var TopNombreMec = ["","","","","","","","","",""];
var TopMotMec = ["","","","","","","","",""];
var TopNombreMou = ["","","","","","","","","",""];
var TopMotMou = ["","","","","","","","",""];

var MoinsNombreAri=["","","","","","","","",""];
var MoinsMotAri=["","","","","","","","",""];
var MoinsNombreMec=["","","","","","","","",""];
var MoinsMotMec=["","","","","","","","",""];
var MoinsNombreMou=["","","","","","","","",""];
var MoinsMotMou=["","","","","","","","",""];

var CranEffets = document.querySelectorAll(".cran");
var CouleurFill = ["#f36f38","#CC2A49","#568ea6"];
var CouleurBtnLight;
var LightBar = document.querySelectorAll(".light-bar");

var NombreMot_Nombre1 = document.querySelector(".nb-words__info--number");
var NombreMot_Nom1 = document.querySelector(".nb-words__info--name");
var NombreMot_Nombre2 = document.querySelector(".nb-words__info--number2");
var NombreMot_Nom2 = document.querySelector(".nb-words__info--name2");
var NombreMot_Nombre3 = document.querySelector(".nb-words__info--number3");
var NombreMot_Nom3 = document.querySelector(".nb-words__info--name3");
var NombreMotCercleBig=document.querySelectorAll(".nb-words--big");
var NombreMotCerclemedium=document.querySelectorAll(".nb-words--medium");
var NombreMotCerclesmall=document.querySelectorAll(".nb-words--small");

var MotMinuteTexte=document.querySelectorAll(".element-description");
var MotMinuteCercle=document.querySelectorAll(".motminutecercle");
var MotMinuteNbr1=document.querySelector(".data-graph--number5");
var MotMinuteNbr2=document.querySelector(".data-graph--number6");
var MotMinuteNbr3=document.querySelector(".data-graph--number7");
var MotMinuteStrong= document.querySelectorAll(".element-colormpm");
var MotMinuteDescription=["Si elle était un véhicule, cette musique serait sûrement un TGV flambant neuf !","Si elle était un véhicule, cette musique serait à coup sûr un skoo-skooter méchamment débridé !","Si elle était un véhicule, cette musique serait au mieux une Fiat Multipla 1ère génération !"];

var DegraderMotMinute=["#Dégradé_sans_nom_24","#Dégradé_sans_nom_21","#Dégradé_sans_nom_26"];
var CouleurTexte=["orange","red","blue"];

//==graphNombredemots==

var AristocrateBtn1 = document.querySelector(".btn__el--aristocrate1");
var MechantBtn1 = document.querySelector(".btn__el--mechants1");
var MoulagaBtn1 = document.querySelector(".btn__el--moulaga1");
var CompteurAristocrateBtn1=0;
var CompteurMechantBtn1=0;
var CompteurMoulagaBtn1=0;
var CompteurClickAristocrateBtn1=0;
var CompteurClickMechantBtn1=0;
var CompteurClickMoulagaBtn1=0;


//==graphmotparminute==

var ListeMpm = document.querySelectorAll(".words-per-min__data--el");
var AristocrateBtn2 = document.querySelector(".btn__el--aristocrate2");
var MechantBtn2 = document.querySelector(".btn__el--mechants2");
var MoulagaBtn2 = document.querySelector(".btn__el--moulaga2");
var CompteurAristocrateBtn2=0;
var CompteurMechantBtn2=0;
var CompteurMoulagaBtn2=0;
var CompteurClickAristocrateBtn2=0;
var CompteurClickMechantBtn2=0;
var CompteurClickMoulagaBtn2=0;

//==graphtop==

var GraphTop10LigneC = document.querySelectorAll(".dix-more__graph--data1");
var GraphTop10Cercle = document.querySelectorAll(".dix-more__graph--data2");
var GraphTop10LigneM = document.querySelectorAll(".dix-more__graph--data3"); 
var GraphTop10Nom = document.querySelectorAll(".element-down__list--name1");
var GraphTop10Nombre = document.querySelectorAll(".element-down__list--number1");

var AristocrateBtn3 = document.querySelector(".btn__el--aristocrate3");
var MechantBtn3 = document.querySelector(".btn__el--mechants3");
var MoulagaBtn3 = document.querySelector(".btn__el--moulaga3");
var CompteurAristocrateBtn3=0;
var CompteurMechantBtn3=0;
var CompteurMoulagaBtn3=0;
var CompteurClickAristocrateBtn3=0;
var CompteurClickMechantBtn3=0;
var CompteurClickMoulagaBtn3=0;

//==graphmoins==

var AristocrateBtn4 = document.querySelector(".btn__el--aristocrate4");
var MechantBtn4 = document.querySelector(".btn__el--mechants4");
var MoulagaBtn4 = document.querySelector(".btn__el--moulaga4");
var CompteurAristocrateBtn4=0;
var CompteurMechantBtn4=0;
var CompteurMoulagaBtn4=0;
var CompteurClickAristocrateBtn4=0;
var CompteurClickMechantBtn4=0;
var CompteurClickMoulagaBtn4=0;

var GraphMoins10LigneC = document.querySelectorAll(".dix-less__graph--data1");
var GraphMoins10Cercle = document.querySelectorAll(".dix-less__graph--data2");
var GraphMoins10LigneM = document.querySelectorAll(".dix-less__graph--data3"); 
var GraphMoins10Nom = document.querySelectorAll(".element-down__list--name2");
var GraphMoins10Nombre = document.querySelectorAll(".element-down__list--number2");

//==GraphStream==

var ListeStream=document.querySelectorAll(".nb-view__data--el");
var AristocrateBtn5 = document.querySelector(".btn__el--aristocrate5");
var MechantBtn5 = document.querySelector(".btn__el--mechants5");
var MoulagaBtn5 = document.querySelector(".btn__el--moulaga5");
var CompteurAristocrateBtn5=0;
var CompteurMechantBtn5=0;
var CompteurMoulagaBtn5=0;
var CompteurClickAristocrateBtn5=0;
var CompteurClickMechantBtn5=0;
var CompteurClickMoulagaBtn5=0;

//==graphVues==

var AristocrateBtn6 = document.querySelector(".btn__el--aristocrate6");
var MechantBtn6 = document.querySelector(".btn__el--mechants6");
var MoulagaBtn6 = document.querySelector(".btn__el--moulaga6");
var GraphCourbeBleu=document.querySelectorAll(".courbeblue");
var GraphCourbeRed=document.querySelectorAll(".courbered");
var GraphCourbeOrange=document.querySelectorAll(".courbeorange");
var CompteurAristocrateBtn6=0;
var CompteurMechantBtn6=0;
var CompteurMoulagaBtn6=0;
var CompteurClickAristocrateBtn6=0;
var CompteurClickMechantBtn6=0;
var CompteurClickMoulagaBtn6=0;


var BtnFooterLeft=document.querySelector(".switch-left");
var BtnFooterRight=document.querySelector(".switch-right");

//=============LandingPage===

var StarterPage=document.querySelector(".starter-page");
var FlecheLandingPage=document.querySelector(".intro__arrow");
var LandingPage=document.querySelector(".intro");

FlecheLandingPage.addEventListener(("click"),(e)=>{
    audioCtx.resume();
    LandingPage.classList.add("hiddenbtn");
});


window.addEventListener(("scroll"),(e)=>{
    audioCtx.resume();
    let position = LandingPage.offsetHeight;
    if(window.scrollY>=position){
        LandingPage.classList.add("hiddenbtn");
    };
});



var BtnRetourLandingPage=document.querySelector(".btn-home__arrow");
BtnRetourLandingPage.addEventListener(("click"),(e)=>{
    StarterPage.classList.remove("hiddenbtn");
    MusiqueMain.classList.add("hiddenbtn");
    MusiqueFooter.classList.add("hiddenbtn");

})

//=============Choix de la musique===

ChoixMusiqueMechant.addEventListener(("click"),(e)=>{
    LesMéchants();
});

ChoixMusiqueArisocrate.addEventListener(("click"),(e)=>{
    Aristocrate();
});

ChoixMusiqueMoulaga.addEventListener(("click"),(e)=>{
    Moulaga();
});

//============= function Choix de la musique===

function BtnAristocrate(){
    BtnFooterLeft.addEventListener(("click"),(e)=>{
        LesMéchants();
    });
    BtnFooterRight.addEventListener(("click"),(e)=>{
        Moulaga();
    });
};

function BtnMechants(){
    BtnFooterLeft.addEventListener(("click"),(e)=>{
        Moulaga();
    });
    BtnFooterRight.addEventListener(("click"),(e)=>{
        Aristocrate();
    });
};

function BtnMoulaga(){
    BtnFooterLeft.addEventListener(("click"),(e)=>{
        Aristocrate();
    });
    BtnFooterRight.addEventListener(("click"),(e)=>{
        LesMéchants();
    });
};

function Aristocrate(){
    audioCtx.resume();
    ChoixMusiqueCompteur=0;
    MusiqueMain.classList.remove("main--les-mechants","main--moulaga","hiddenbtn");
    MusiqueMain.classList.add("main--aristocrate");
    MusiqueFooter.classList.remove("footer--les-mechants","footer--moulaga","hiddenbtn");
    MusiqueFooter.classList.add("footer--aristocrate");
    for(let i=0; i<ElementCouleur.length; i++){
    ElementCouleur[i].classList.remove("red","blue");
    ElementCouleur[i].classList.add("orange");
    };
    BtnFooterRight.classList.remove("orange","red");
    BtnFooterLeft.classList.remove("blue","orange");
    BtnFooterRight.innerHTML="Moulaga";
    BtnFooterRight.classList.add("blue");
    BtnFooterLeft.innerHTML="Les Méchants";
    BtnFooterLeft.classList.add("red");
    ResetColor();
    resetcaroucouleur();
    carouaffi();
    for(let i=0; i<BtnSideAristocrate.length; i++){
        BtnSideAristocrate[i].classList.add("hiddenbtn");
    };
    StarterPage.classList.add("hiddenbtn");
    myAudio.setAttribute("src","assets/data/Aristocrate.mp3");
    BPM=117;
    BtnAristocrate();
    setlightbase();
    ComparaisonListeTop();
    ComparaisonListeMoins();
    GraphCourbeVues();
    GraphStream();
    GraphMpm();
    SectionNombreDeMots();
};

function LesMéchants(){
    audioCtx.resume();
    ChoixMusiqueCompteur=1;
    MusiqueMain.classList.remove("main--aristocrate","main--moulaga","hiddenbtn");
    MusiqueMain.classList.add("main--les-mechants");
    MusiqueFooter.classList.remove("footer--aristocrate","footer--moulaga","hiddenbtn");
    MusiqueFooter.classList.add("footer--les-mechants");
    for(let i=0; i<ElementCouleur.length; i++){
        ElementCouleur[i].classList.remove("orange","blue");
        ElementCouleur[i].classList.add("red");
    };
    BtnFooterLeft.classList.remove("orange","red");
    BtnFooterRight.classList.remove("blue","red");
    BtnFooterLeft.innerHTML="Moulaga";
    BtnFooterLeft.classList.add("blue");
    BtnFooterRight.innerHTML="Aristocrate";
    BtnFooterRight.classList.add("orange");
    ResetColor();
    resetcaroucouleur();
    carouaffi();
    for(let i=0; i<BtnSideMechants.length; i++){
        BtnSideMechants[i].classList.add("hiddenbtn");
    };
    StarterPage.classList.add("hiddenbtn");
    myAudio.setAttribute("src","assets/data/Mechants.mp3");
    BPM=96;
    BtnMechants();
    setlightbase();
    ComparaisonListeTop();
    ComparaisonListeMoins();
    GraphCourbeVues();
    GraphStream();
    GraphMpm();
    SectionNombreDeMots();
};

function Moulaga(){
    audioCtx.resume();
    ChoixMusiqueCompteur=2;
    MusiqueMain.classList.remove("main--les-mechants","main--aristocrate","hiddenbtn");
    MusiqueMain.classList.add("main--moulaga");
    MusiqueFooter.classList.remove("footer--aristocrate","footer--les-mechants","hiddenbtn");
    MusiqueFooter.classList.add("footer--moulaga");
    for(let i=0; i<ElementCouleur.length; i++){
    ElementCouleur[i].classList.remove("orange","red");
    ElementCouleur[i].classList.add("blue");
    };
    BtnFooterLeft.classList.remove("blue","red");
    BtnFooterRight.classList.remove("blue","orange");
    BtnFooterLeft.innerHTML="Aristocrate";
    BtnFooterLeft.classList.add("orange");
    BtnFooterRight.innerHTML="Les Méchants";
    BtnFooterRight.classList.add("red");
    ResetColor();
    resetcaroucouleur();
    carouaffi();
    for(let i=0; i<BtnSideMoulaga.length; i++){
        BtnSideMoulaga[i].classList.add("hiddenbtn");
    };
    StarterPage.classList.add("hiddenbtn");
    myAudio.setAttribute("src","assets/data/Moulaga.mp3");
    BPM=125;
    BtnMoulaga();
    setlightbase();
    ComparaisonListeTop();
    ComparaisonListeMoins();
    GraphCourbeVues();
    GraphStream();
    GraphMpm();
    SectionNombreDeMots();
}

//=============fetch + infos===

fetch('https://julienma.be/projets/anciens/dataplay2019/assets/data/infos.json')
.then((reponse)=>{
    return reponse.json();
})
.then((json)=>{
    for(let i=0; i<MusiqueJson.length; i++){
        var NomMusique = MusiqueJson[i];
        if(i==0){


            //=============Texte===

            var AristoText = json[NomMusique][0][InfosJson[14]];
            const AristoMot = AristoText.toLowerCase().split(" ");
            var MotTotalAristocrate = AristoMot.length;


            //=============Mot/Minute===

            var TempsAri = json[NomMusique][0][InfosJson[5]];
            var MotLongueurAri = AristoMot.length;
            var MotParMinuteAri = Math.round(Number(MotLongueurAri)/Number(TempsAri)*60);


            //=============Compteur mot===

            var NombreMots = {};
            for (let mot of AristoMot) {    
                if (mot.length>2){
                    if (NombreMots[mot] == undefined) {
                        NombreMots[mot] = 1;
                    }else{
                        NombreMots[mot] += 1;
                    }
                }
            };

            
            //=============top10===

            var TableauTop10 = [];
            var x = 0;
            Object.getOwnPropertyNames(NombreMots).forEach(
                function(val) {
                    if(NombreMots[val] != 0){
                        TableauTop10[x] = {};
                        TableauTop10[x]["nombre"] = NombreMots[val];
                        TableauTop10[x]["nom"] = val;
                        TableauTop10[x]["couleur"] = CouleurFill[0];
                        x++;
                    }
                }
            );

            TableauTop10.sort(function (a,b){
                return b.nombre - a.nombre;
            });

            for(let y = 0; y<10; y++){
                TopNombreAri[y] = TableauTop10[y]["nombre"];
                TopMotAri[y] = TableauTop10[y]["nom"];
            }
            
            
            //=============moins10===

            var TableauMoins10 = [];
            var w = 0;
            Object.getOwnPropertyNames(NombreMots).forEach(
                function(val) {
                    if(NombreMots[val]>2){
                        TableauMoins10[w] = {};
                        TableauMoins10[w]["nombre"] = NombreMots[val];
                        TableauMoins10[w]["nom"] = val;
                        w++;
                    }
                }
            );

            TableauMoins10.sort(function (a,b){
                return a.nombre - b.nombre;
            });

            for(let k = 0; k<10; k++){
                MoinsNombreAri[k]=TableauMoins10[k]["nombre"];
                MoinsMotAri[k]=TableauMoins10[k]["nom"];
            }
            

            //=============Choix de la musique===

            ChoixMusiqueArisocrate.addEventListener(("click"),(e)=>{
                TitreMusique.innerHTML = json["Aristocrate"][0][InfosJson[2]];
                SmallArtiste.innerHTML = json["Aristocrate"][0][InfosJson[0]];
                TitreChoixMusique.innerHTML = json["Aristocrate"][0][InfosJson[2]];
            });
        }else if(i==1){
                

            //=============Texte===
    
            var MechantText = json[NomMusique][0][InfosJson[14]];
            const MechantMot = MechantText.toLowerCase().split(" ");
            var MotTotalMechant=MechantMot.length;

            
            //=============Mot/Minute===

            var TempsMec = json[NomMusique][0][InfosJson[5]];
            var MotLongueurMec = MechantMot.length;
            var MotParMinuteMec = Math.round(Number(MotLongueurMec)/Number(TempsMec)*60);

            
            //=============Compteur mot===

            var NombreMots = {};
            for (let mot of MechantMot) {    
                if (mot.length>2){
                    if (NombreMots[mot] == undefined) {
                        NombreMots[mot] = 1;
                    } else {
                        NombreMots[mot] += 1;
                    }
                }
            };


            //=============top10===

            var TableauTop10 = [];
            var x = 0;
            Object.getOwnPropertyNames(NombreMots).forEach(
                function(val) {
                    if(NombreMots[val] != 0){
                        TableauTop10[x] = {};
                        TableauTop10[x]["nombre"] = NombreMots[val];
                        TableauTop10[x]["nom"] = val;
                        TableauTop10[x]["couleur"] = CouleurFill[1];
                        x++;
                    }
                }
            );

            TableauTop10.sort(function (a,b){
                return b.nombre - a.nombre;
            });

            for(let y = 0; y<10; y++){
                TopNombreMec[y] = TableauTop10[y]["nombre"];
                TopMotMec[y] = TableauTop10[y]["nom"];
            }


            //=============Moins10===

            var TableauMoins10 = [];
            var w = 0;
            Object.getOwnPropertyNames(NombreMots).forEach(
                function(val) {
                    if(NombreMots[val]>2){
                        TableauMoins10[w] = {};
                        TableauMoins10[w]["nombre"] = NombreMots[val];
                        TableauMoins10[w]["nom"] = val;
                        w++;
                    }
                }
            );

            TableauMoins10.sort(function (a,b){
                return a.nombre - b.nombre;
            });

            for(let k = 0; k<10; k++){
                MoinsNombreMec[k] = TableauMoins10[k]["nombre"];
                MoinsMotMec[k] = TableauMoins10[k]["nom"];
            }
            

            //=============Choix de la musique===
            
            ChoixMusiqueMechant.addEventListener(("click"),(e)=>{
                TitreMusique.innerHTML = json["Les Méchants"][0][InfosJson[2]];
                SmallArtiste.innerHTML = json["Les Méchants"][0][InfosJson[0]];
                TitreChoixMusique.innerHTML = json["Les Méchants"][0][InfosJson[2]];
            });
        }else{
            

            //=============Texte===

            var MoulagaText = json[NomMusique][0][InfosJson[14]];
            const MoulagaMot = MoulagaText.toLowerCase().split(" ");
            var MotTotalMoulaga=MoulagaMot.length;


            //=============Mot/Minute===

            var TempsMou = json[NomMusique][0][InfosJson[5]];
            var MotLongueurMou = MoulagaMot.length;
            var MotParMinuteMou = Math.round(Number(MotLongueurMou)/Number(TempsMou)*60);


            //=============Compteur mot===

            var NombreMots = [];
            for (let mot of MoulagaMot) {    
                if (mot.length>2){
                    if(mot=="do-do-donnez"){
                        mot ="donnez"
                    }
                    if(NombreMots[mot] == undefined) {
                        NombreMots[mot] = 1;
                    } else {
                        NombreMots[mot] += 1;
                    }
                }
            };
            

            //=============top10===

            var TableauTop10 = [];
            var x = 0;
            Object.getOwnPropertyNames(NombreMots).forEach(
                function(val) {
                    if(NombreMots[val] != 0){
                        TableauTop10[x] ={ };
                        TableauTop10[x]["nombre"] = NombreMots[val];
                        TableauTop10[x]["nom"] = val;
                        TableauTop10[x]["couleur"] = CouleurFill[2];
                        x++;
                    }
                }
            );
    
            TableauTop10.sort(function (a,b){
                return b.nombre - a.nombre;
            });
    
            for(let y = 0; y<10; y++){
                TopNombreMou[y] = TableauTop10[y]["nombre"];
                TopMotMou[y] = TableauTop10[y]["nom"];
            }

            
            //=============Moins10===

            var TableauMoins10 = [];
            var w = 0;
            Object.getOwnPropertyNames(NombreMots).forEach(
                function(val) {
                    if(NombreMots[val]>2){
                        TableauMoins10[w] = {};
                        TableauMoins10[w]["nombre"] = NombreMots[val];
                        TableauMoins10[w]["nom"] = val;
                        w++;
                    }
                }
            );

            TableauMoins10.sort(function (a,b){
                return a.nombre - b.nombre;
            });

            for(let k = 0; k<10; k++){
                MoinsNombreMou[k] = TableauMoins10[k]["nombre"];
                MoinsMotMou[k] = TableauMoins10[k]["nom"];
            };


            //=============Choix de la musique===
            
            ChoixMusiqueMoulaga.addEventListener(("click"),(e)=>{
                TitreMusique.innerHTML=json["Moulaga"][0][InfosJson[2]];
                SmallArtiste.innerHTML=json["Moulaga"][0][InfosJson[0]]+" & "+json["Moulaga"][0][InfosJson[1]];
                TitreChoixMusique.innerHTML=json["Moulaga"][0][InfosJson[2]];
            });
        };

        //=============Section Nombre Mot===

        var MotTotalMusique=[MotTotalAristocrate,MotTotalMechant,MotTotalMoulaga];
        var NombreMotTotalNombre=[NombreMot_Nombre1,NombreMot_Nombre2,NombreMot_Nombre3];
        var NombreMotTotalNom=[NombreMot_Nom1,NombreMot_Nom2,NombreMot_Nom3];
        var MotTotalLongueur=[];
        for(let i=0; i<3; i++){
            MotTotalLongueur[i]={};
            MotTotalLongueur[i]["Nombre"]=MotTotalMusique[i];
            MotTotalLongueur[i]["Nom"]=MusiqueJson[i];
            MotTotalLongueur[i]["Couleur"]=CouleurFill[i];
        }

        MotTotalLongueur.sort(function (a,b){
            return b.Nombre - a.Nombre;
        });

        for(let i=0; i<3; i++){
            NombreMotTotalNombre[i].innerHTML=MotTotalLongueur[i]["Nombre"];
            NombreMotTotalNom[i].innerHTML=MotTotalLongueur[i]["Nom"];
            for(let j=0; j<2; j++){
                if(i==0){
                    NombreMotCercleBig[j].setAttribute("style","fill:"+MotTotalLongueur[i]["Couleur"]);
                }else if(i==1){
                    NombreMotCerclemedium[j].setAttribute("style","fill:"+MotTotalLongueur[i]["Couleur"]);
                }else{
                    NombreMotCerclesmall[j].setAttribute("style","fill:"+MotTotalLongueur[i]["Couleur"]);
                };
            };
        };


        //=============Section Mot minute===
        
        var MotMinuteMusique=[MotParMinuteAri,MotParMinuteMec,MotParMinuteMou];
        var MotMinuteNbrTotal=[MotMinuteNbr1,MotMinuteNbr2,MotMinuteNbr3];
        
        var MotTotalMinute=[];
        for(let i=0; i<3; i++){
            MotTotalMinute[i]={};
            MotTotalMinute[i]["Vitesse"]=MotMinuteMusique[i];
            MotTotalMinute[i]["Nom"]=MusiqueJson[i];
            MotTotalMinute[i]["Couleur"]=CouleurTexte[i];
            MotTotalMinute[i]["Dégradé"]=DegraderMotMinute[i];
        };

        MotTotalMinute.sort(function (a,b){
            return b.Vitesse - a.Vitesse;
        });

        for(let i=0; i<3; i++){
            MotMinuteNbrTotal[i].innerHTML=MotTotalMinute[i]["Vitesse"];
            MotMinuteCercle[i].setAttribute("style","fill:url("+MotTotalMinute[i]["Dégradé"]+")");
            MotMinuteStrong[i].innerHTML=MotTotalMinute[i]["Nom"];
            for(let j=0; j<3; j++){
                MotMinuteStrong[i].classList.remove(CouleurTexte[j]);
            };
            MotMinuteStrong[i].classList.add(MotTotalMinute[i]["Couleur"]);
            MotMinuteTexte[i].innerHTML=MotMinuteDescription[i];
        };


        //=============Nombres de vues + infos===

        var NombreNbv = document.querySelectorAll(".data-graph--number4");
        var CercleCouleurNbv=document.querySelectorAll(".cerclendv");
        var RectangleCouleurNbv=document.querySelectorAll(".rectndv");
        var DescriptionNbv1=document.querySelectorAll(".nb-view__details1");
        var DescriptionNbv2=document.querySelectorAll(".nb-view__details2");
        var DescriptionNbv3=document.querySelectorAll(".nb-view__details3");
        var StreamTotalnbr=["36313100","37307146","31030392"];
        var StreamTotalnbrCara=["36 313K","37 307K","31 030K"];
        var NombreVueTotal=[];
        for(let i=0; i<3; i++){
            NombreVueTotal[i]={};
            NombreVueTotal[i]["Vues"]=Number(StreamTotalnbr[i]);
            NombreVueTotal[i]["VuesCara"]=StreamTotalnbrCara[i];
            NombreVueTotal[i]["Nom"]=MusiqueJson[i];
            NombreVueTotal[i]["Couleur"]=CouleurFill[i];
            NombreVueTotal[i]["SemaineMax"]=json[MusiqueJson[i]][0][InfosJson[18]];
            NombreVueTotal[i]["MoisMax"]=json[MusiqueJson[i]][0][InfosJson[16]];
            NombreVueTotal[i]["Certification"]=json[MusiqueJson[i]][0][InfosJson[6]];
            NombreVueTotal[i]["Description"]=json[MusiqueJson[i]][0][InfosJson[7]];

        };

        NombreVueTotal.sort(function (a,b){
            return b.Vues - a.Vues;
        });

        for(let i=0; i<3; i++){
            NombreNbv[i].innerHTML=NombreVueTotal[i]["VuesCara"];
            CercleCouleurNbv[i].setAttribute("style","fill:"+NombreVueTotal[i]["Couleur"]);
            RectangleCouleurNbv[i].setAttribute("style","fill:"+NombreVueTotal[i]["Couleur"]);
            if(i==0){
                DescriptionNbv1[0].innerHTML="Peak semaine : "+NombreVueTotal[i]["SemaineMax"];
                DescriptionNbv1[1].innerHTML="Peak mois : "+NombreVueTotal[i]["MoisMax"];
                DescriptionNbv1[2].innerHTML=NombreVueTotal[i]["Certification"];
                DescriptionNbv1[3].innerHTML=NombreVueTotal[i]["Description"];
            }else if(i==1){
                DescriptionNbv2[0].innerHTML="Peak semaine : "+NombreVueTotal[i]["SemaineMax"];
                DescriptionNbv2[1].innerHTML="Peak mois : "+NombreVueTotal[i]["MoisMax"];
                DescriptionNbv2[2].innerHTML=NombreVueTotal[i]["Certification"];
                DescriptionNbv2[3].innerHTML=NombreVueTotal[i]["Description"];
            }else{
                DescriptionNbv3[0].innerHTML="Peak semaine : "+NombreVueTotal[i]["SemaineMax"];
                DescriptionNbv3[1].innerHTML="Peak mois : "+NombreVueTotal[i]["MoisMax"];
                DescriptionNbv3[2].innerHTML=NombreVueTotal[i]["Certification"];
                DescriptionNbv3[3].innerHTML=NombreVueTotal[i]["Description"];
            };
        };
    }; 
});



//=============GraphiquesMpm===

AristocrateBtn1.addEventListener(("click"),(e)=>{
    if(CompteurClickAristocrateBtn1%2==0){
        CompteurAristocrateBtn1=1;
    }else{
        CompteurAristocrateBtn1=0;
    };
    CompteurClickAristocrateBtn1++;
    SectionNombreDeMots();
});

MechantBtn1.addEventListener(("click"),(e)=>{
    if(CompteurClickMechantBtn1%2==0){
        CompteurMechantBtn1=1;
    }else{
        CompteurMechantBtn1=0;
    };
    CompteurClickMechantBtn1++;
    SectionNombreDeMots();
});

MoulagaBtn1.addEventListener(("click"),(e)=>{
    if(CompteurClickMoulagaBtn1%2==0){
        CompteurMoulagaBtn1=1;
    }else{
        CompteurMoulagaBtn1=0;
    };
    CompteurClickMoulagaBtn1++;
    SectionNombreDeMots();
});

var NombreMotBig=document.querySelector(".nb-words__info--big");
var NombreMotMid=document.querySelector(".nb-words__info--mid");
var NombreMotLittle=document.querySelector(".nb-words__info--little");


function SectionNombreDeMots(){
    if(ChoixMusiqueCompteur==0 || CompteurAristocrateBtn1==1){
        for(let i=0; i<2; i++){
            NombreMotCerclesmall[i].setAttribute("opacity","1");
        };
        NombreMotLittle.classList.remove("hiddenop");
    }else{
        for(let i=0; i<2; i++){
            NombreMotCerclesmall[i].setAttribute("opacity","0");
        };
        NombreMotLittle.classList.add("hiddenop");
    };
    if(ChoixMusiqueCompteur==1 || CompteurMechantBtn1==1){
        for(let i=0; i<2; i++){
            NombreMotCerclemedium[i].setAttribute("opacity","1");
        };
        NombreMotMid.classList.remove("hiddenop");
    }else{
        for(let i=0; i<2; i++){
            NombreMotCerclemedium[i].setAttribute("opacity","0");
        };
        NombreMotMid.classList.add("hiddenop");
    };
    if(ChoixMusiqueCompteur==2 || CompteurMoulagaBtn1==1){
        for(let i=0; i<2; i++){
            NombreMotCercleBig[i].setAttribute("opacity","1");
        };
        NombreMotBig.classList.remove("hiddenop");
    }else{
        for(let i=0; i<2; i++){
            NombreMotCercleBig[i].setAttribute("opacity","0");
        };
        NombreMotBig.classList.add("hiddenop");
    };
};
//=============GraphiquesMpm===

AristocrateBtn2.addEventListener(("click"),(e)=>{
    if(CompteurClickAristocrateBtn2%2==0){
        CompteurAristocrateBtn2=1;
    }else{
        CompteurAristocrateBtn2=0;
    }
    CompteurClickAristocrateBtn2++;
    GraphMpm();
});

MechantBtn2.addEventListener(("click"),(e)=>{
    if(CompteurClickMechantBtn2%2==0){
        CompteurMechantBtn2=1;
    }else{
        CompteurMechantBtn2=0;
    }
    CompteurClickMechantBtn2++;
    GraphMpm();
});

MoulagaBtn2.addEventListener(("click"),(e)=>{
    if(CompteurClickMoulagaBtn2%2==0){
        CompteurMoulagaBtn2=1;
    }else{
        CompteurMoulagaBtn2=0;
    }
    CompteurClickMoulagaBtn2++;
    GraphMpm();
});


function GraphMpm(){
    if(ChoixMusiqueCompteur==0 || CompteurAristocrateBtn2==1){
        ListeMpm[1].classList.remove("hiddenop");
    }else{
        ListeMpm[1].classList.add("hiddenop");
    };
    if(ChoixMusiqueCompteur==1 || CompteurMechantBtn2==1){
        ListeMpm[2].classList.remove("hiddenop");
    }else{
        ListeMpm[2].classList.add("hiddenop");
    };
    if(ChoixMusiqueCompteur==2 || CompteurMoulagaBtn2==1){
        ListeMpm[0].classList.remove("hiddenop");
    }else{
        ListeMpm[0].classList.add("hiddenop");
    };
};

//=============ListeMotTop10all===

AristocrateBtn3.addEventListener(("click"),(e)=>{
    if(CompteurClickAristocrateBtn3%2==0){
        CompteurAristocrateBtn3=1;
    }else{
        CompteurAristocrateBtn3=0;
    }
    CompteurClickAristocrateBtn3++;
    ComparaisonListeTop();
});

MechantBtn3.addEventListener(("click"),(e)=>{
    if(CompteurClickMechantBtn3%2==0){
        CompteurMechantBtn3=1;
    }else{
        CompteurMechantBtn3=0;
    }
    CompteurClickMechantBtn3++;
    ComparaisonListeTop();
});

MoulagaBtn3.addEventListener(("click"),(e)=>{
    if(CompteurClickMoulagaBtn3%2==0){
        CompteurMoulagaBtn3=1;
    }else{
        CompteurMoulagaBtn3=0;
    }
    CompteurClickMoulagaBtn3++;
    ComparaisonListeTop();
});

function ComparaisonListeTop(){

    var ListeTopStockage=[];
    let Compteur=0;

    if(ChoixMusiqueCompteur==0 || CompteurAristocrateBtn3==1){
        for(let i=0; i<10; i++){
            ListeTopStockage[Compteur]={};
            ListeTopStockage[Compteur]["Nombre"]=TopNombreAri[i];
            ListeTopStockage[Compteur]["Nom"]=TopMotAri[i];
            ListeTopStockage[Compteur]["Couleur"]=CouleurFill[0];
            Compteur++;
        };
    };
    if(ChoixMusiqueCompteur==1 || CompteurMechantBtn3==1){
        for(let i=0; i<10; i++){
            ListeTopStockage[Compteur]={};
            ListeTopStockage[Compteur]["Nombre"]=TopNombreMec[i];
            ListeTopStockage[Compteur]["Nom"]=TopMotMec[i];
            ListeTopStockage[Compteur]["Couleur"]=CouleurFill[1];
            Compteur++;
        };
    };
    if(ChoixMusiqueCompteur==2 || CompteurMoulagaBtn3==1){
        for(let i=0; i<10; i++){
            ListeTopStockage[Compteur]={};
            ListeTopStockage[Compteur]["Nombre"]=TopNombreMou[i];
            ListeTopStockage[Compteur]["Nom"]=TopMotMou[i];
            ListeTopStockage[Compteur]["Couleur"]=CouleurFill[2];
            Compteur++;
        };
    };
    ListeTopStockage.sort(function (a,b){
        return b.Nombre - a.Nombre;
    });

    for(let i=0; i<10; i++){
        GraphTop10LigneC[i].setAttribute("style","fill:"+ListeTopStockage[i]["Couleur"]);
        GraphTop10Cercle[i].setAttribute("style","fill:"+ListeTopStockage[i]["Couleur"]);
        GraphTop10LigneM[i].setAttribute("style","fill:"+ListeTopStockage[i]["Couleur"]);
        GraphTop10Nom[i].innerHTML=ListeTopStockage[i]["Nom"];
        GraphTop10Nombre[i].innerHTML=ListeTopStockage[i]["Nombre"];
    };
};


//=============ListeMotMoins10all===

AristocrateBtn4.addEventListener(("click"),(e)=>{
    if(CompteurClickAristocrateBtn4%2==0){
        CompteurAristocrateBtn4=1;
    }else{
        CompteurAristocrateBtn4=0;
    }
    CompteurClickAristocrateBtn4++;
    ComparaisonListeMoins();
});

MechantBtn4.addEventListener(("click"),(e)=>{
    if(CompteurClickMechantBtn4%2==0){
        CompteurMechantBtn4=1;
    }else{
        CompteurMechantBtn4=0;
    }
    CompteurClickMechantBtn4++;
    ComparaisonListeMoins();
});

MoulagaBtn4.addEventListener(("click"),(e)=>{
    if(CompteurClickMoulagaBtn4%2==0){
        CompteurMoulagaBtn4=1;
    }else{
        CompteurMoulagaBtn4=0;
    }
    CompteurClickMoulagaBtn4++;
    ComparaisonListeMoins();
});

function ComparaisonListeMoins(){

    var ListeMoinsStockage=[];
    let Compteur=0;

    if(ChoixMusiqueCompteur==0 || CompteurAristocrateBtn4==1){
        for(let i=0; i<10; i++){
            ListeMoinsStockage[Compteur]={};
            ListeMoinsStockage[Compteur]["Nombre"]=MoinsNombreAri[i];
            ListeMoinsStockage[Compteur]["Nom"]=MoinsMotAri[i];
            ListeMoinsStockage[Compteur]["Couleur"]=CouleurFill[0];
            Compteur++;
        };
    };
    if(ChoixMusiqueCompteur==1 || CompteurMechantBtn4==1){
        for(let i=0; i<10; i++){
            ListeMoinsStockage[Compteur]={};
            ListeMoinsStockage[Compteur]["Nombre"]=MoinsNombreMec[i];
            ListeMoinsStockage[Compteur]["Nom"]=MoinsMotMec[i];
            ListeMoinsStockage[Compteur]["Couleur"]=CouleurFill[1];
            Compteur++;
        };
    };
    if(ChoixMusiqueCompteur==2 || CompteurMoulagaBtn4==1){
        for(let i=0; i<10; i++){
            ListeMoinsStockage[Compteur]={};
            ListeMoinsStockage[Compteur]["Nombre"]=MoinsNombreMou[i];
            ListeMoinsStockage[Compteur]["Nom"]=MoinsMotMou[i];
            ListeMoinsStockage[Compteur]["Couleur"]=CouleurFill[2];
            Compteur++;
        };
    };
    ListeMoinsStockage.sort(function (a,b){
        return a.Nombre - b.Nombre;
    });

    for(let i=0; i<10; i++){
        GraphMoins10LigneC[i].setAttribute("style","fill:"+ListeMoinsStockage[i]["Couleur"]);
        GraphMoins10Cercle[i].setAttribute("style","fill:"+ListeMoinsStockage[i]["Couleur"]);
        GraphMoins10LigneM[i].setAttribute("style","fill:"+ListeMoinsStockage[i]["Couleur"]);
        GraphMoins10Nom[i].innerHTML=ListeMoinsStockage[i]["Nom"];
        GraphMoins10Nombre[i].innerHTML=ListeMoinsStockage[i]["Nombre"];
    };
};


//=============GraphiquesVuesParMoi===

AristocrateBtn5.addEventListener(("click"),(e)=>{
    if(CompteurClickAristocrateBtn5%2==0){
        CompteurAristocrateBtn5=1;
    }else{
        CompteurAristocrateBtn5=0;
    }
    GraphStream();
    CompteurClickAristocrateBtn5++;
});

MechantBtn5.addEventListener(("click"),(e)=>{
    if(CompteurClickMechantBtn5%2==0){
        CompteurMechantBtn5=1;
    }else{
        CompteurMechantBtn5=0;
    }
    GraphStream();
    CompteurClickMechantBtn5++;
});

MoulagaBtn5.addEventListener(("click"),(e)=>{
    if(CompteurClickMoulagaBtn5%2==0){
        CompteurMoulagaBtn5=1;
    }else{
        CompteurMoulagaBtn5=0;
    }
    GraphStream();
    CompteurClickMoulagaBtn5++;
});


function GraphStream(){
    if(ChoixMusiqueCompteur==0 || CompteurAristocrateBtn5==1){
        ListeStream[1].classList.remove("hiddenop");
    }else{
        ListeStream[1].classList.add("hiddenop");
    };
    if(ChoixMusiqueCompteur==1 || CompteurMechantBtn5==1){
        ListeStream[0].classList.remove("hiddenop");
    }else{
        ListeStream[0].classList.add("hiddenop");
    };
    if(ChoixMusiqueCompteur==2 || CompteurMoulagaBtn5==1){
        ListeStream[2].classList.remove("hiddenop");
    }else{
        ListeStream[2].classList.add("hiddenop");
    };
};


//=============GraphiquesVuesParMoi===

AristocrateBtn6.addEventListener(("click"),(e)=>{
    if(CompteurClickAristocrateBtn6%2==0){
        CompteurAristocrateBtn6=1;
    }else{
        CompteurAristocrateBtn6=0;
    }
    CompteurClickAristocrateBtn6++;
    GraphCourbeVues();
});

MechantBtn6.addEventListener(("click"),(e)=>{
    if(CompteurClickMechantBtn6%2==0){
        CompteurMechantBtn6=1;
    }else{
        CompteurMechantBtn6=0;
    }
    CompteurClickMechantBtn6++;
    GraphCourbeVues();
});

MoulagaBtn6.addEventListener(("click"),(e)=>{
    if(CompteurClickMoulagaBtn6%2==0){
        CompteurMoulagaBtn6=1;
    }else{
        CompteurMoulagaBtn6=0;
    }
    CompteurClickMoulagaBtn6++;
    GraphCourbeVues();
});


function GraphCourbeVues(){

    if(ChoixMusiqueCompteur==0 || CompteurAristocrateBtn6==1){
        for(let i=0; i<16; i++){
            GraphCourbeOrange[i].setAttribute("opacity","1");
        };
    }else{
        for(let i=0; i<16; i++){
            GraphCourbeOrange[i].setAttribute("opacity","0");
        };
    };
    if(ChoixMusiqueCompteur==1 || CompteurMechantBtn6==1){
        for(let i=0; i<17; i++){
            GraphCourbeRed[i].setAttribute("opacity","1");
        };
    }else{
        for(let i=0; i<17; i++){
            GraphCourbeRed[i].setAttribute("opacity","0");
        };
    };
    if(ChoixMusiqueCompteur==2 || CompteurMoulagaBtn6==1){
        for(let i=0; i<5; i++){
            GraphCourbeBleu[i].setAttribute("opacity","1");
        };
    }else{
        for(let i=0; i<5; i++){
            GraphCourbeBleu[i].setAttribute("opacity","0");
        };
    };
};


//=============ResetTopMoins10Liste===



function ResetColor(){

    CompteurAristocrateBtn1=0;
    CompteurMechantBtn1=0;
    CompteurMoulagaBtn1=0;
    CompteurClickAristocrateBtn1=0;
    CompteurClickMechantBtn1=0;
    CompteurClickMoulagaBtn1=0;
    CompteurAristocrateBtn2=0;
    CompteurMechantBtn2=0;
    CompteurMoulagaBtn2=0;
    CompteurClickAristocrateBtn2=0;
    CompteurClickMechantBtn2=0;
    CompteurClickMoulagaBtn2=0;
    CompteurClickAristocrateBtn3=0;
    CompteurClickMechantBtn3=0;
    CompteurClickMoulagaBtn3=0;
    CompteurAristocrateBtn3=0;
    CompteurMechantBtn3=0;
    CompteurMoulagaBtn3=0;
    CompteurClickAristocrateBtn4=0;
    CompteurClickMechantBtn4=0;
    CompteurClickMoulagaBtn4=0;
    CompteurAristocrateBtn4=0;
    CompteurMechantBtn4=0;
    CompteurMoulagaBtn4=0;
    CompteurAristocrateBtn5=0;
    CompteurMechantBtn5=0;
    CompteurMoulagaBtn5=0;
    CompteurClickAristocrateBtn5=0;
    CompteurClickMechantBtn5=0;
    CompteurClickMoulagaBtn5=0;
    CompteurClickAristocrateBtn6=0;
    CompteurClickMechantBtn6=0;
    CompteurClickMoulagaBtn6=0;
    CompteurAristocrateBtn6=0;
    CompteurMechantBtn6=0;
    CompteurMoulagaBtn6=0;
    btnclick=0;

    for(let i=0; i<10; i++){
        GraphTop10LigneC[i].setAttribute("style","fill:#1d1d1b");
        GraphTop10Cercle[i].setAttribute("style","fill:#1d1d1b");
        GraphTop10LigneM[i].setAttribute("style","fill:#1d1d1b");
        GraphMoins10LigneC[i].setAttribute("style","fill:#1d1d1b");
        GraphMoins10Cercle[i].setAttribute("style","fill:#1d1d1b");
        GraphMoins10LigneM[i].setAttribute("style","fill:#1d1d1b");
    };
    for(let i=0; i<16; i++){
        GraphCourbeOrange[i].setAttribute("opacity","0");
    };
    for(let i=0; i<17; i++){
        GraphCourbeRed[i].setAttribute("opacity","0");
    };
    for(let i=0; i<5; i++){
        GraphCourbeBleu[i].setAttribute("opacity","0");
    };

    for(let i=0; i<BtnSide.length; i++){
        BtnSide[i].classList.remove("hiddenbtn");
    }
};

//============= Reset Carousel Nom Filtre===


function carouaffi(){
    EffetFirst.innerHTML=listeEffets[5];
    EffetActive.innerHTML=listeEffets[0];
    EffetSecond.innerHTML=listeEffets[1];
    EffetDescription.innerHTML=listeExplain[0];

};


//=============Carousel Nom Filtre===

EffetFirst.innerHTML=listeEffets[5];
EffetActive.innerHTML=listeEffets[btnclick];
EffetSecond.innerHTML=listeEffets[btnclick+1];
EffetDescription.innerHTML=listeExplain[btnclick];

FlecheGauche.addEventListener(("click"),(e)=>{
    btnclick=btnclick-1;
    
    if(btnclick==0){
        EffetFirst.innerHTML=listeEffets[5];
        EffetActive.innerHTML=listeEffets[btnclick];
        EffetSecond.innerHTML=listeEffets[1];
    }else if(btnclick<0){
        btnclick=5;
        EffetFirst.innerHTML=listeEffets[btnclick-1];
        EffetActive.innerHTML=listeEffets[btnclick];
        EffetSecond.innerHTML=listeEffets[0];
    }else{
        EffetFirst.innerHTML=listeEffets[btnclick-1];
        EffetActive.innerHTML=listeEffets[btnclick];
        EffetSecond.innerHTML=listeEffets[btnclick+1];
    };
    EffetDescription.innerHTML=listeExplain[btnclick];
    cranbtneffet();
    resetcranbtneffet();
});

FlecheDroite.addEventListener(("click"),(e)=>{
    btnclick=btnclick+1;

    if(btnclick==5){
        EffetFirst.innerHTML=listeEffets[btnclick-1];
        EffetActive.innerHTML=listeEffets[btnclick];
        EffetSecond.innerHTML=listeEffets[0];
    }else if(btnclick>5){
        btnclick=0;
        EffetFirst.innerHTML=listeEffets[5];
        EffetActive.innerHTML=listeEffets[btnclick];
        EffetSecond.innerHTML=listeEffets[btnclick+1];
    }else{
        EffetFirst.innerHTML=listeEffets[btnclick-1];
        EffetActive.innerHTML=listeEffets[btnclick];
        EffetSecond.innerHTML=listeEffets[btnclick+1];
    };
    EffetDescription.innerHTML=listeExplain[btnclick];
    cranbtneffet();
    resetcranbtneffet();
});

FlecheHome.addEventListener(("click"),(e)=>{
    ResetColor();
    cranbtneffet();
    resetcranbtneffet();
    resetcaroucouleur();
})

//=============Fonction Couleur Musique base===

function setlightbase(){
    if(ChoixMusiqueCompteur==0){
        CouleurBtnLight=CouleurFill[0];
    }
    if(ChoixMusiqueCompteur==1){
        CouleurBtnLight=CouleurFill[1];
    }
    if(ChoixMusiqueCompteur==2){
        CouleurBtnLight=CouleurFill[2];
    }
    EffetActive.style.color=CouleurBtnLight;
    LightBar[btnclick].setAttribute("style","fill:"+CouleurBtnLight);
    CranEffets[4].setAttribute("style","fill:"+CouleurBtnLight);
    FlecheHome.setAttribute("style","fill:"+CouleurBtnLight);
};


//=============Fonction reset couleur cran===

var btnplace=document.querySelector(".oria");

function resetcranbtneffet(){
    for(let i=0; i<4; i++){
        CranEffets[i].setAttribute("style","fill:#1d1d1b");
    }
    btnplace.style.transform="rotate(125deg)";
};


//=============Fonction reset couleur carousel==

function resetcaroucouleur(){
    for(let i=0; i<6; i++){
        LightBar[i].setAttribute("style","fill:#1d1d1b");
    };
};




//=============Fonction Couleur Musique base  Cran/Carousel===

function cranbtneffet(alpha){
    if(ChoixMusiqueCompteur==0){
        CouleurBtnLight=CouleurFill[0];
    };
    if(ChoixMusiqueCompteur==1){
        CouleurBtnLight=CouleurFill[1];
    };
    if(ChoixMusiqueCompteur==2){
        CouleurBtnLight=CouleurFill[2];
    };
    cran(alpha,CouleurBtnLight);   
};

function cran(alpha,CouleurBtnLight){
    if(alpha==225){
        for(let i=4; i>=0; i--){
            if(i>=0){   
                CranEffets[i].setAttribute("style","fill:"+CouleurBtnLight);
            }else{
                CranEffets[i].setAttribute("style","fill:#1d1d1b");
            };
        };
    };
    if(alpha==200){
        for(let i=4; i>=0; i--){
            if(i>=1){   
                CranEffets[i].setAttribute("style","fill:"+CouleurBtnLight);
            }else{
                CranEffets[i].setAttribute("style","fill:#1d1d1b");
            };
        };
    };
    if(alpha==175){
        for(let i=4; i>=0; i--){
            if(i>=2){   
                CranEffets[i].setAttribute("style","fill:"+CouleurBtnLight);
            }else{
                CranEffets[i].setAttribute("style","fill:#1d1d1b");
            };
        };
    };
    if(alpha==150){
        for(let i=4; i>=0; i--){
            if(i>=3){   
                CranEffets[i].setAttribute("style","fill:"+CouleurBtnLight);
            }else{
                CranEffets[i].setAttribute("style","fill:#1d1d1b");
            };
        };
    };
    if(alpha==125){
        for(let i=4; i>=0; i--){
            if(i>=4){   
                CranEffets[i].setAttribute("style","fill:"+CouleurBtnLight);
            }else{
                CranEffets[i].setAttribute("style","fill:#1d1d1b");
            };
        };
    };


    if(btnclick>0 && btnclick<=5){
        LightBar[btnclick-1].setAttribute("style"," fill: #1d1d1b");
        LightBar[btnclick].setAttribute("style","fill:"+CouleurBtnLight);
    };
    if(btnclick==0){
        LightBar[5].setAttribute("style"," fill: #1d1d1b");
        LightBar[btnclick].setAttribute("style","fill:"+CouleurBtnLight);
    };

    if(btnclick>=0 && btnclick<5){
        LightBar[btnclick+1].setAttribute("style"," fill: #1d1d1b");
        LightBar[btnclick].setAttribute("style","fill:"+CouleurBtnLight);
    };
    if(btnclick==5){
        LightBar[0].setAttribute("style"," fill: #1d1d1b");
        LightBar[btnclick].setAttribute("style","fill:"+CouleurBtnLight);
    } ;  
};


//=============Fonction Bouton Rotation // https://codes-sources.commentcamarche.net/source/54202-bouton-rotatif Repris  et Modifié===

var ListeGaucheEffet = document.querySelectorAll(".audio-list--left--el");
var ListeDroiteEffet = document.querySelectorAll(".audio-list--right--el");


function bouplio(conteneur,bouton){
		
    this.conte=document.getElementById(conteneur);
    this.bout=document.getElementById(bouton);
    var that=this;
    
    this.boupliev=function(e){
        e.preventDefault();
        that.boupli(e);
        var dde=document.documentElement;
        
        dde.addEventListener("mousemove", that.boupli, false);
        dde.addEventListener("mouseup", that.bouplino, false);
    }

    this.bouplino=function(e){

        var dde=document.documentElement;
        dde.removeEventListener("mousemove", that.boupli, false);
        dde.removeEventListener("mouseup", that.bouplino, false);
    }
    
    this.boupli=function(e){

        var lui=that.conte;
        var el=that.bout;
        var dde=(navigator.vendor) ? document.body : document.documentElement;
        var left=0;
        var top=-1130;
        var element=lui;
        
        while (element) {
            left += element.offsetLeft;
            top += element.offsetTop;
            element = element.offsetParent;
        }
        
        var X =((left+(lui.offsetWidth/2))-(e.clientX + dde.scrollLeft));
		var Y =((top+(lui.offsetHeight/2))-(e.clientY + dde.scrollTop));
        
        var alpha=Math.round((Math.atan(Y/X))*(180/Math.PI))+90;
        
        if(X>=0){
            alpha=alpha+180;
        }
        
        if(btnclick==0){
            if(alpha<=125){
                alpha=125;
                biquadFilter2.type="allpass";
                ListeGaucheEffet[1].innerHTML="0 High";
                cranbtneffet(alpha);
            }else if(alpha>=225){
                alpha=225;
            }else if(alpha<150 && alpha>125){
                alpha=150;
                biquadFilter2.type="highpass";
                biquadFilter2.frequency.setValueAtTime(500, audioCtx.currentTime);
                ListeGaucheEffet[1].innerHTML="500 High";
                cranbtneffet(alpha);
            }else if(alpha<175 && alpha>150){
                alpha=175;
                biquadFilter2.type="highpass";
                biquadFilter2.frequency.setValueAtTime(1000, audioCtx.currentTime);
                ListeGaucheEffet[1].innerHTML="1000 High";
                cranbtneffet(alpha);
            }else if(alpha<200 && alpha>175){
                alpha=200;
                biquadFilter2.type="highpass";
                biquadFilter2.frequency.setValueAtTime(1500, audioCtx.currentTime);
                ListeGaucheEffet[1].innerHTML="1500 High";
                cranbtneffet(alpha);
            }else if(alpha<225 && alpha>200){
                alpha=225;
                biquadFilter2.type="highpass";
                biquadFilter2.frequency.setValueAtTime(2000, audioCtx.currentTime); 
                ListeGaucheEffet[1].innerHTML="2000 High";
                cranbtneffet(alpha);
            };
        };
        if(btnclick==1){
            if(alpha<=125){
                alpha=125;
                biquadFilter.type="allpass";
                ListeGaucheEffet[2].innerHTML="0 Low";
                cranbtneffet(alpha);
            }else if(alpha>=225){
                alpha=225;
            }else if(alpha<150 && alpha>125){
                alpha=150;
                biquadFilter.type="lowpass";
                biquadFilter.frequency.setValueAtTime(1500, audioCtx.currentTime);
                ListeGaucheEffet[2].innerHTML="1500 Low";
                cranbtneffet(alpha);
            }else if(alpha<175 && alpha>150){
                alpha=175;
                biquadFilter.type="lowpass";
                biquadFilter.frequency.setValueAtTime(1000, audioCtx.currentTime);
                ListeGaucheEffet[2].innerHTML="1000 Low";
                cranbtneffet(alpha);
            }else if(alpha<200 && alpha>175){
                alpha=200;
                biquadFilter.type="lowpass";
                biquadFilter.frequency.setValueAtTime(400, audioCtx.currentTime);
                ListeGaucheEffet[2].innerHTML="400 Low";
                cranbtneffet(alpha);
            }else if(alpha<225 && alpha>200){
                alpha=225;
                biquadFilter.type="lowpass";
                biquadFilter.frequency.setValueAtTime(100, audioCtx.currentTime); 
                ListeGaucheEffet[2].innerHTML="100 Low";
                cranbtneffet(alpha);
            };
        };
        if(btnclick==2){
            if(alpha<=125){
                alpha=125;
                myAudio.playbackRate =0.5;
                ListeGaucheEffet[0].innerHTML=BPM*0.5+" BPM";
                cranbtneffet(alpha);
            }else if(alpha>=225){
                alpha=225;
            }else if(alpha<150 && alpha>125){
                alpha=150;
                myAudio.playbackRate =0.75;
                ListeGaucheEffet[0].innerHTML=BPM*0.75+" BPM";
                cranbtneffet(alpha);
            }else if(alpha<175 && alpha>150){
                alpha=175;
                myAudio.playbackRate =1;
                ListeGaucheEffet[0].innerHTML=BPM+" BPM";
                cranbtneffet(alpha);
            }else if(alpha<200 && alpha>175){
                alpha=200;
                myAudio.playbackRate =1.5;
                ListeGaucheEffet[0].innerHTML=BPM*1.5+" BPM";
                cranbtneffet(alpha);
            }else if(alpha<225 && alpha>200){
                alpha=225;
                myAudio.playbackRate =2;
                ListeGaucheEffet[0].innerHTML=BPM*2+" BPM";
                cranbtneffet(alpha);
            };
        };
        if(btnclick==3){
            if(alpha<=125){
                alpha=125;
                distortion.curve = makeDistortionCurve(0);
                distortion.oversample = '4x';
                ListeDroiteEffet[0].innerHTML="0 Distortion";
                cranbtneffet(alpha);
            }else if(alpha>=225){
                alpha=225;
            }else if(alpha<150 && alpha>125){
                alpha=150;
                distortion.curve = makeDistortionCurve(10);
                distortion.oversample = '4x';
                ListeDroiteEffet[0].innerHTML="10 Distortion";
                cranbtneffet(alpha);
            }else if(alpha<175 && alpha>150){
                alpha=175;
                distortion.curve = makeDistortionCurve(20);
                distortion.oversample = '4x';
                ListeDroiteEffet[0].innerHTML="20 Distortion";
                cranbtneffet(alpha);
            }else if(alpha<200 && alpha>175){
                alpha=200;
                distortion.curve = makeDistortionCurve(30);
                distortion.oversample = '4x';
                ListeDroiteEffet[0].innerHTML="30 Distortion";
                cranbtneffet(alpha);
            }else if(alpha<225 && alpha>200){
                alpha=225;
                distortion.curve = makeDistortionCurve(35);
                distortion.oversample = '4x';
                ListeDroiteEffet[0].innerHTML="35 Distortion";
                cranbtneffet(alpha);
            };
        };
        if(btnclick==4){
            if(alpha<=125){
                alpha=125;
                biquadFilter3.type="allpass";
                ListeDroiteEffet[1].innerHTML="0 Passe-bande";
                cranbtneffet(alpha);
            }else if(alpha>=225){
                alpha=225;
            }else if(alpha<150 && alpha>125){
                alpha=150;
                biquadFilter3.type="bandpass";
                biquadFilter3.frequency.setValueAtTime(500, audioCtx.currentTime);
                ListeDroiteEffet[1].innerHTML="500 Passe-bande";
                cranbtneffet(alpha);
            }else if(alpha<175 && alpha>150){
                alpha=175;
                biquadFilter3.type="bandpass";
                biquadFilter3.frequency.setValueAtTime(1000, audioCtx.currentTime);
                ListeDroiteEffet[1].innerHTML="1000 Passe-bande";
                cranbtneffet(alpha);
            }else if(alpha<200 && alpha>175){
                alpha=200;
                biquadFilter3.type="bandpass";
                biquadFilter3.frequency.setValueAtTime(1500, audioCtx.currentTime);
                ListeDroiteEffet[1].innerHTML="1500 Passe-bande";
                cranbtneffet(alpha);
            }else if(alpha<225 && alpha>200){
                alpha=225;
                biquadFilter3.type="bandpass";
                biquadFilter3.frequency.setValueAtTime(2000, audioCtx.currentTime); 
                ListeDroiteEffet[1].innerHTML="2000 Passe-bande";
                cranbtneffet(alpha);
            };
        };
        if(btnclick==5){
            if(alpha<=125){
                alpha=125;
                biquadFilter4.type="allpass";
                ListeDroiteEffet[2].innerHTML="0 Coupe-bande";
                cranbtneffet(alpha);
            }else if(alpha>=225){
                alpha=225;
            }else if(alpha<150 && alpha>125){
                alpha=150;
                biquadFilter4.type="notch";
                biquadFilter4.frequency.setValueAtTime(500, audioCtx.currentTime);
                ListeDroiteEffet[2].innerHTML="500 Coupe-bande";
                cranbtneffet(alpha);
            }else if(alpha<175 && alpha>150){
                alpha=175;
                biquadFilter4.type="notch";
                biquadFilter4.frequency.setValueAtTime(1000, audioCtx.currentTime);
                ListeDroiteEffet[2].innerHTML="1000 Coupe-bande";
                cranbtneffet(alpha);
            }else if(alpha<200 && alpha>175){
                alpha=200;
                biquadFilter4.type="notch";
                biquadFilter4.frequency.setValueAtTime(1500, audioCtx.currentTime);
                ListeDroiteEffet[2].innerHTML="1500 Coupe-bande";
                cranbtneffet(alpha);
            }else if(alpha<225 && alpha>200){
                alpha=225;
                biquadFilter4.type="notch";
                biquadFilter4.frequency.setValueAtTime(2000, audioCtx.currentTime); 
                ListeDroiteEffet[2].innerHTML="2000 Coupe-bande";
                cranbtneffet(alpha);
            };
        };

        var effet='rotate('+alpha+'deg)';

        el.style.WebkitTransform=effet;
        el.style.OTransform=effet;
        el.style.MozTransform=effet;
        el.style.msTransform=effet;
        el.style.transform=effet;
    }
    this.bout.addEventListener('mousedown', this.boupliev, false);	   
};


onload=init

function init(){
    var boubou1;
    boubou1=new bouplio('dgbout','oria');
};




